export const GET_PROFILE_NFT_INITIAL = 'GET_PROFILE_NFT_INITIAL';
export const GET_PROFILE_NFT_SUCCESS = 'GET_PROFILE_NFT_SUCCESS';
export const GET_PROFILE_NFT_FAILURE = 'GET_PROFILE_NFT_FAILURE';

export const GET_PROFILE_DATA_INITIAL = 'GET_PROFILE_DATA_INITIAL';
export const GET_PROFILE_DATA_SUCCESS = 'GET_PROFILE_DATA_SUCCESS';
export const GET_PROFILE_DATA_FAILURE = 'GET_PROFILE_DATA_FAILURE';